var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjInputNumber",
    {
      attrs: {
        disabled: _vm.disabled,
        readonly: _vm.readonly,
        size: _vm.size,
        placeholder: _vm.placeholder || _vm.$t("inputText"),
        maxlength: _vm.maxlength,
        max: _vm.max,
        min: _vm.min,
        clearable: _vm.clearable,
        "per-milage": _vm.perMilage,
        precision: _vm.precision,
        "not-auto-zero": _vm.notAutoZero,
      },
      on: { blur: _vm.onBlur },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    [
      _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2),
      _c("template", { slot: "append" }, [_vm._t("append")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }